import { Api } from "../../api";
import { ApiClient } from "../../api/client";

export const setErrors = (errors) => {
  return async (dispatch) => {
    dispatch({ type: "SET_ERRORS", payload: errors });
  };
};

export const getDeliveryList = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const response = await Api.cart.getDeliveryList(Redis, reset);
    dispatch({ type: "SET_DELIVERY_LIST", payload: response || [] });
  };
};

export const getPaymentList = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const response = await Api.cart.getPaymentList(Redis, reset);
    dispatch({ type: "SET_PAYMENT_LIST", payload: response });
  };
};

export const getShops = (Redis = false, reset = false) => {
  return async (dispatch) => {
    const allShops = await Api.databaseContent.getShops(Redis, reset);
    dispatch({ type: "SET_CART_SHOPS", payload: allShops });
  };
};

export const setParams = (params) => {
  return async (dispatch) => {
    dispatch({ type: "SET_ERRORS", payload: [] });
    dispatch({ type: "SET_CART_PARAMS", payload: params });
  };
};

export const setParam = (param) => {
  return async (dispatch) => {
    dispatch({ type: "SET_ERRORS", payload: [] });
    dispatch({ type: "SET_CART_PARAM", payload: param });
  };
};

export const getSdekData = (cityName) => {
  return async (dispatch) => {
    dispatch({ type: "SET_SDEK_DATA_LOADING", payload: true });
    const response = await ApiClient.sdek.getPoints(cityName);
    dispatch({ type: "SET_SDEK_DATA", payload: response || [] });
    dispatch({ type: "SET_SDEK_DATA_LOADING", payload: false });
  };
};

export const resetSdekData = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_SDEK_DATA", payload: null });
  };
};

export const getEdostData = (cityName, regionName, kladrId) => {
  return async (dispatch) => {
    dispatch({ type: "SET_EDOST_DATA_LOADED", payload: false });
    dispatch({ type: "SET_EDOST_DATA", payload: {} });
    dispatch({ type: "SET_EDOST_DATA_LOADING", payload: true });
    const response = await ApiClient.cart.getEdostData(
      cityName,
      regionName,
      kladrId,
    );
    dispatch({ type: "SET_EDOST_DATA", payload: response || {} });
    dispatch({ type: "SET_EDOST_DATA_LOADING", payload: false });
    dispatch({ type: "SET_EDOST_DATA_LOADED", payload: true });
  };
};

// --- Новые сервисы доставки (nestFarkopDatabase). Используются только cartNew. ---
// Пишут в те же поля state.cart (sdekData/edostData), но в НОВОЙ форме ответа
// (sdek: [{id,address,gpsLat,...}]; edost: {companies, pickupPoints}).

export const getSdekDataNew = (cityName) => {
  return async (dispatch) => {
    dispatch({ type: "SET_SDEK_DATA_LOADING", payload: true });
    const response = await ApiClient.sdek.getPointsNew(cityName);
    dispatch({ type: "SET_SDEK_DATA", payload: response || [] });
    dispatch({ type: "SET_SDEK_DATA_LOADING", payload: false });
  };
};

/**
 * @param {string} cityName
 * @param {string} [regionName]
 * @param {string} [kladrId]
 * @param {string} [zip]
 * @param {{ ITEMS?: any[] } | null} [basket] Корзину можно передать явно
 *   (карточка товара); иначе берётся из стора.
 */
export const getEdostDataNew = (
  cityName,
  regionName = "",
  kladrId = "",
  zip = "",
  basket = null,
  isReset = false,
) => {
  return async (dispatch, getState) => {
    dispatch({ type: "SET_EDOST_DATA_LOADED", payload: false });
    dispatch({ type: "SET_EDOST_DATA", payload: {} });
    dispatch({ type: "SET_EDOST_DATA_LOADING", payload: true });

    // Корзину можно передать явно (карточка товара); иначе берём из стора.
    const sourceBasket = basket || getState().cart.basket;
    const products = (sourceBasket?.ITEMS || [])
      .map((item) => ({
        id: Number(item.PRODUCT_ID),
        quantity: Number(item.QUANTITY) || 1,
      }))
      .filter((product) => product.id);

    let edostData = {};
    try {
      // 1) тарифы ТК (без ПВЗ)
      const calc = await ApiClient.edost.calculate({
        products,
        city: cityName,
        region: regionName,
        kladr: kladrId,
        zip,
      });
      const pickupPoints = await ApiClient.edost.getOffices(
        { city: cityName, region: regionName, zip },
        isReset,
      );
      edostData = { ...calc, pickupPoints: pickupPoints || {} };
    } catch (e) {
      edostData = {};
    }

    dispatch({ type: "SET_EDOST_DATA", payload: edostData });
    dispatch({ type: "SET_EDOST_DATA_LOADING", payload: false });
    dispatch({ type: "SET_EDOST_DATA_LOADED", payload: true });
  };
};

// Данные перемещения товаров корзины на склады ТК (TC_<id>): companies (для
// сопоставления тарифа eDost со складом ТК по имени) + products (время
// перемещения по каждому товару). Используется в deliveryMap для расчёта
// суммарного времени доставки в pointInfo.
export const fetchDeliveryTk = (productIds) => {
  return async (dispatch) => {
    dispatch({ type: "SET_DELIVERY_TK_LOADING", payload: true });
    try {
      const data = await ApiClient.cart.getCartDeliveryTk(productIds);
      dispatch({ type: "SET_DELIVERY_TK_DATA", payload: data || null });
    } catch (e) {
      dispatch({ type: "SET_DELIVERY_TK_DATA", payload: null });
    } finally {
      dispatch({ type: "SET_DELIVERY_TK_LOADING", payload: false });
    }
  };
};

export const fetchProductShopDelivery = (productIds) => {
  return async (dispatch, getState) => {
    const { cartShops } = getState().cart;

    const warehouseIds = cartShops
      .map((shop) => shop.data?.warehouseId)
      .filter(Boolean);

    dispatch({ type: "SET_PRODUCT_SHOP_DELIVERY_LOADING", payload: true });
    try {
      const data = await Api.server.getProductDelivery(
        productIds,
        warehouseIds,
      );
      // apiCallWrapper при ошибке не бросает, а возвращает null — тогда
      // Object.keys(productShopDeliveryDays) в карте ронял корзину целиком.
      dispatch({
        type: "SET_PRODUCT_SHOP_DELIVERY_DAYS",
        payload: data || {},
      });
    } catch (e) {
      dispatch({ type: "SET_PRODUCT_SHOP_DELIVERY_DAYS", payload: {} });
    } finally {
      dispatch({ type: "SET_PRODUCT_SHOP_DELIVERY_LOADING", payload: false });
    }
  };
};
